import type { ReactNode } from 'react';

import { useTheme } from '@emotion/react';

import { Typography } from '../../../../atoms/typography';
import { useBannerContext } from '../../banner.context';

import * as styles from './banner-title.styles';

type Props = {
  children: ReactNode;
  className?: string;
  highlighted?: boolean;
};

export const BannerTitle = ({ children, className, highlighted = false }: Props) => {
  const theme = useTheme();
  const { size, variant } = useBannerContext();

  return (
    <Typography
      className={[className, highlighted && 'banner-title-highlighted'].filter(Boolean).join(' ')}
      color="textPrimary"
      component="h2"
      css={[
        styles.text,
        styles.textSize[size](theme),
        theme.presentation.banner.title,
        highlighted && styles.textVariant[variant](theme),
        highlighted && styles.textUppercase,
        highlighted && theme.presentation.banner.uppercase,
      ]}
      fontWeight={highlighted ? 'medium' : 'regular'}
      variant="b3">
      {children}
    </Typography>
  );
};
